import React from 'react'
import {Input} from 'reactstrap'
import {getIn} from 'formik'

const SelectComponent = (props) => {
  const {
    label,
    options,
    disabled,

    // Formik's context
    formik: {
      values,
      setFieldValue,
      setFieldTouched,
    },
  } = props

  const minPrice = getIn(values, 'minPrice')
  const maxPrice = getIn(values, 'maxPrice')
  const value = [minPrice || '', maxPrice || ''].join(',')

  return (
    <Input
      type='select'
      value={value}
      onChange={(e) => {
        // eslint-disable-next-line no-shadow
        const [minPrice, maxPrice] = e.target.value.split(',')

        setFieldValue('minPrice', +minPrice)
        setFieldValue('maxPrice', +maxPrice)
      }}
      onBlur={() => {
        setFieldTouched('minPrice', true)
        setFieldTouched('maxPrice', true)
      }}
      disabled={disabled}
    >
      <option value=''>{label}</option>

      {options.map((option, index) => (
        <option
          key={index}
          value={option.value}
        >
          {option.label}
        </option>
      ))}
    </Input>
  )
}

export default SelectComponent
